<script>

import { convert } from './ui.js';
    import { res, state, ui, prefs } from './stores.js';
    import LogCard from './LogCard.svelte';

    import { performanceReview } from './campaign.js';
    import { renderCost } from './costs.js';
    import { upperInitial } from './parse.js';
    import { possArray } from './card_actions.js';

    export let c;

    export let showUsername = false;

    console.log(c);
</script>

<div class="campaign_info bold">
    <div>
        {c.captain} {#if showUsername}({c.username}){/if}, level '{c.level}'
    </div>
</div>
<div class="campaign_info">
    {#if c.ended}
        Campaign completed after {c.games.length}: final rank {c.currentRank}.
        <div>
            Performance review: {performanceReview(c)}
        </div>
    {:else}
        {c.games.length} games played so far, {c.games.filter(g => g.won).length} opponent(s) defeated, current rank {c.currentRank}
        <div>
            Next bot level: {c.nextBotLevel}
        </div>
    {/if}
</div>
<div>Games so far:</div>
<table>
    <tr>
       <th>Opponent</th><th>Result</th><th>Score</th><th>Reward</th>
    </tr>
    {#each c.games as c}
    <tr>
        <td>{c.enemy}</td>
        <td>{c.won ? 'Win' : 'Loss'}</td>
        <td>{c.humanScore}&mdash;{c.botScore}</td>
        <td>
            {#if c.reward}
                {#if c.reward.type == 'add_common' || c.reward.type == 'add_reserve'}
                    Add {#each possArray(c.reward.card) as card}
                        <LogCard textSize=1.5 c={$res.cards.find(cd => cd.id == card.id)} />
                    {/each} 
                {:else if c.reward.type == 'extra_draw'}
                    Draw {c.reward.amount} extra cards in your starting hand
                {:else if c.reward.type == 'gain'}
                    Gain {c.reward.amount} {@html convert(Array.isArray(c.reward.gain) ? c.reward.gain.map(g => `[[${g}]]`).join('/') : `[[${c.reward.gain}]]`)} at start of each game
                {:else if c.reward.type == 'away_team'}
                    {@html `Send 1 [[away team]] at the start of each game`}
                {:else if c.reward.type == 'log'}
                    Log 1 card from Starting or Reserve deck at the start of each game
                {:else if c.reward.type == 'choose_starter'}
                    Choose {c.reward.amount} card for your starting hand each game
                {:else if c.reward.type == 'free_play'}
                    Free play a {@html convert(`[[${c.reward.filter}]]`)} at start of each game
                {:else if c.reward.type == 'discard_reinforcement'}
                    Discard a card from Reinforcements at start of each game
                {:else if c.reward.type == 'from_junk'}
                    You can gain/scan {@html convert(c.reward.filter ? c.reward.filter.map(f => `[[${f}]]`).join('/') : '')} from junk {c.reward.cost ? `by paying ${c.reward.cost.num} [[${c.reward.cost.resource}]]` : ''}
                {:else if c.reward.type == 'starter_gain_junk'}
                    After drawing the starting hand, gain {c.reward.num} card from junk
                {:else if c.reward.type == 'gain_when_junk'}
                    Whenever junking a card, gain {c.reward.num} [[{c.reward.specific}]]
                {:else if c.reward.text}
                    {@html convert(c.reward.text, true)}
                {/if}
            {:else}
                No reward
            {/if}
        </td>
    </tr>
    {/each}
</table>
<div class="line">

</div>

<style>
    table, tr, td, th {
        border: 1px solid white;
        border-collapse: collapse;
    }

    .bold {
        font-weight: bold;
    }

    .campaign_info {
        margin-bottom: 2px;
        padding-bottom: 2px;
    }
    
    .line {
        border-bottom: 2px solid white;
        margin-bottom: 5px;
        padding-bottom: 5px;
    }
</style>